export default __webpack_public_path__ + "static/media/GlimpseOfLifeMobileViewImage6.be04ee82.png";